import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import api from "../../utilis/api";

const OrderDetail = () => {
  const { id } = useParams();
  const [orders, setOrders] = useState({});
  const token = useSelector((state) => state.user.token) || "";

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await api.get(`/orders/order/${id}`, {
          headers: { authorization: `Bearer ${token}` },
        });
        setOrders(response.data.data.order); // note: order, not orders
      } catch (err) {
        console.error(err.response?.data || err);
      }
    };

    if (token) fetchOrder();
  }, [token, id]);

  return (
    <>
      <Helmet>
        <title>My Order Details</title>
        <meta name="description" content="Welcome to My Orders page" />
      </Helmet>

      <div className="w-full px-4 md:px-8 lg:px-16 py-8">
        <h1 className="text-center font-bold text-[1.8rem] mb-6">My Orders</h1>

        {/* Orders Table */}
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-[600px] border-separate border-spacing-y-4">
            <thead>
              <tr className="text-left text-gray-600 text-sm uppercase tracking-wider">
                <th className="px-4 py-3 w-[55%]">Products Detail</th>
                <th className="px-4 py-3 w-[15%] text-center">Quantity</th>
                <th className="px-4 py-3 w-[15%]">Price</th>
                <th className="px-4 py-3 w-[15%]">Total</th>
              </tr>
            </thead>

            <tbody>
              {orders?.orderItems?.map((item, index) => (
                <tr
                  key={index}
                  className="bg-[#f5f5f5] hover:shadow-md transition-all duration-300 rounded-xl"
                >
                  {/* Product Detail */}
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded-lg"
                      />
                      <div>
                        <h1 className="font-semibold text-gray-800 text-sm sm:text-base">
                          {item.name}
                        </h1>
                      </div>
                    </div>
                  </td>

                  {/* Quantity */}
                  <td className="px-4 py-3 text-center font-medium">
                    {item.qty}
                  </td>

                  {/* Price */}
                  <td className="px-4 py-3 font-medium text-gray-700">
                    ${item.price}
                  </td>

                  {/* Total */}
                  <td className="px-4 py-3 font-semibold text-gray-900">
                    ${(item.price * item.qty).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Order Summary */}
        <div className="mt-6 p-4 sm:p-6 rounded-lg bg-gray-100 shadow-md">
          <h2 className="text-lg sm:text-xl font-semibold mb-4 text-gray-700">
            Order Summary
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-800">
            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Items Price:</span>
              <span className="font-semibold">${orders?.itemsPrice}</span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Tax:</span>
              <span className="font-semibold">${orders?.taxPrice}</span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Shipping Price:</span>
              <span className="font-semibold">${orders.shippingPrice}</span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Shipping Method:</span>
              <span className="font-semibold capitalize">
                {orders.shippingMethod}
              </span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Total Price:</span>
              <span className="font-semibold text-green-700">
                ${orders.totalPrice}
              </span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Payment Status:</span>
              <span
                className={`font-semibold ${
                  orders.paymentStatus === "Paid"
                    ? "text-green-600"
                    : "text-yellow-600"
                }`}
              >
                {orders.paymentStatus}
              </span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Order Status:</span>
              <span
                className={`font-semibold ${
                  orders.orderStatus === "Delivered"
                    ? "text-green-600"
                    : orders.orderStatus === "Processing"
                      ? "text-blue-600"
                      : "text-red-600"
                }`}
              >
                {orders.orderStatus}
              </span>
            </div>

            <div className="flex justify-between bg-white p-3 rounded-md shadow-sm">
              <span>Paid:</span>
              <span
                className={`${orders.isPaid ? "text-green-600" : "text-red-600"} font-semibold`}
              >
                {orders.isPaid ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetail;
